import prize from './prize2022.json'

const gifing = {
  prize
}

export default gifing
